var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcInfluencerVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 6c0-3.333-1.334-4.667-4.667-4.667H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667h4c3.333 0 4.667-1.334 4.667-4.667V6zM1.68 4.74h12.64M5.68 1.407v3.24M10.32 1.407v2.94",
    stroke: "#655AEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.833c0-1.026.727-1.446 1.613-.933l.694.4.693.4c.887.513.887 1.353 0 1.867l-.693.4-.694.4c-.886.513-1.613.093-1.613-.934v-.8h0v-.8z",
    stroke: "#A39CF4"
  }))));
}

export default SvgIcInfluencerVideo;